// import external libraries
import { useTranslation } from 'react-i18next';

// import components
import { MultiSelect } from 'components/shared';

// import utils
import { renderFilterTags } from '../../BacklogFilters.utils';

// import types
import type { FilterOption } from '../../../../Backlog.types';
import type { BacklogActivityFilterProps } from './BacklogActivityFilter.types';

/**
 * The activity filter: the one filter that means the same thing in every view, so it sits above the section
 * of the entity on screen.
 *
 * The same field the employee and function filters are — the shared MultiSelect, with a checkbox per option
 * and one line summarising the selection — so the popover reads as one set of controls rather than one
 * dropdown per filter.
 */
const BacklogActivityFilter = ({
  options,
  selected,
  onChange
}: BacklogActivityFilterProps) => {
  'use memo';

  // The field's own name sits under the backlog namespace; the count wording ("2 geselecteerd") at the root
  // of common, shared with the app's other compact multi-selects.
  const { t } = useTranslation('common', { keyPrefix: 'backlog' });
  const { t: tCommon } = useTranslation('common');

  return (
    <MultiSelect<FilterOption>
      label={t('filters.activity')}
      options={options}
      selectedOptions={selected}
      onChange={onChange}
      optionLabelProp="name"
      // The shared MultiSelect ships without a clear button; a filter a planner cannot empty in one go is a
      // filter they have to untick value by value.
      disableClearable={false}
      renderTags={renderFilterTags(
        ({ name }) => name,
        tCommon('selected').toLowerCase()
      )}
    />
  );
};

export default BacklogActivityFilter;
